<script>
  import Sidebar from '../../components/Sidebar.vue'
  import Topbar from '../../components/Topbar.vue'
  import services from '@/http'
  import toast from '@/methods/toast'
  import messages from '@/methods/messages'

  export default {
      name: 'config',
      components: {
          Sidebar,
          Topbar
      },
      data () {
          return {
            form: {
              cnpj: '',
              ativo: 0
            }
          }
      },
      methods: {
          validData () {
            if (!this.form.cnpj.trim()) {
              toast.toastError('Informe todos os campos antes de alterar!')
              return false
            }

            return true
          },
          sendData () {
            if (this.validData()) {
              services.auth.emitentesAtivo(this.form)
              .then(() => {
                toast.toastSuccess('Emitente alterado com sucesso!')
              })
              .catch((res) => {
                let msg = messages.getMessage(res, 'Emitente não encontrado!')
                toast.toastError(msg)
              })
            }
          }
      }
  }
</script>

<template>
  <div class="">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <Topbar />
    <div id="wrapper">
      <Sidebar />
        <div class="card size-card mx-auto mt-5">
          <p class="card-header text-center bg-blue-dt">Painel</p>
          <p class="p-3 text-secondary">
            Ao clicar em enviar, o emitente informado será marcado pra monitorar ou não no painel de acompanhamento
          </p>

          <div class="card-body">
            <form @submit.prevent="sendData()">
              <div class="form-group">

                <div class="form-group">
                  <label for="pass">Ativo</label>
                  <div class="input-group">                    

                    <select
                      class="form-control"
                      name="ativo"
                      v-model="form.ativo"
                    >
                      <option v-for="subitem in [{id: 1, description: 'Sim'}, {id: 0, description: 'Não'}]" :key="subitem.id" :value="subitem.id">
                        {{subitem.description}}
                      </option>
                    </select>

                  </div>
                </div>

                <div class="form-group">
                  <label for="pass">CPF/CNPJ</label>
                  <div class="input-group">                    
                    <input v-model="form.cnpj" type="cnpj" class="form-control" id="cnpj" placeholder="CPF/CNPJ">
                  </div>
                </div>
                <div class="m-0 p-0 card-body text-right">
                  <button type="submit" class="btn bg-blue-dt">Gravar</button>
                </div>
              </div>  
            </form>
          </div>    
      </div>
    </div>
  </div>
</template>

<style>
    .size-card{
      width: 90%;
      max-width: 400px
    }
</style>